<template>
	<div></div>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: 'chat',
	computed: {
		...mapState({
			parametrosSistema: (state) => state.parametrosSistema,
		}),
		url() {
			return this.parametrosSistema.urlChat
		},
	},
	async created() {
		this.start()
		const chatContainer = await this.adicionarBotaoFechar()
		await this.adicionarBotaoReabrir(chatContainer)
	},
	methods: {
		start() {
			let s1 = document.createElement('script'),
				s0 = document.getElementsByTagName('script')[0]

			s1.id = 'chat-suporte'
			s1.async = true
			s1.src = 'https://storage.googleapis.com/push-webchat/wwc-latest.js'
			s1.charset ='UTF-8'

			s1.onload = () => {
				let l = document.createElement('script')
				l.id = 'chat-token'
				l.async = true
				l.src = this.url
				l.charset = 'UTF-8'
				l.setAttribute('crossorigin','*')
				s0.parentNode.insertBefore(l, s1.nextSibling)
			}

			s0.parentNode.insertBefore(s1, s0)
		},
		async adicionarBotaoFechar() {
			let chatContainer = await this.buscarElemento('.push-widget-container')
			let chatButton = document.querySelector('.push-launcher')
			let botaoFechar = document.querySelector('.botao-fechar-chat')
			if (!botaoFechar) this.adicionarElementoFechar(chatContainer, chatButton)

			return chatContainer
		},
		async buscarElemento(elemento) {
			let chat
			await new Promise(resolve => {
				const intervalo = setInterval(() => {
					chat = document.querySelector(elemento)

					if (chat) {
						clearInterval(intervalo)
						resolve()
					}
				}, 1000)
			})

			return chat
		},
		adicionarElementoFechar(chatContainer, chatButton) {
			const botaoFechar = document.createElement('div')
			botaoFechar.innerHTML = 'X'
			chatContainer.insertBefore(botaoFechar, chatButton)
			botaoFechar.classList.add('botao-fechar-chat')

			botaoFechar.style.position = 'relative'
			botaoFechar.style.top = '17px'
			botaoFechar.style.right = '3px'
			botaoFechar.style.backgroundColor = '#e57373'
			botaoFechar.style.borderRadius = '50%'
			botaoFechar.style.height = '20px'
			botaoFechar.style.width = '20px'
			botaoFechar.style.display = 'flex'
			botaoFechar.style.justifyContent = 'center'
			botaoFechar.style.alignItems = 'center'
			botaoFechar.style.color = 'white'
			botaoFechar.style.fontWeight = 'bold'
			botaoFechar.style.fontSize = '11px'
			botaoFechar.style.cursor = 'pointer'

			botaoFechar.addEventListener('click', () => {
				chatContainer.style.display = 'none'
				document.querySelector('.botao-reabrir-chat').style.display = 'flex'
			})
		},
		adicionarBotaoReabrir(chatContainer) {
			const botaoReabrir = document.createElement('div')
			botaoReabrir.classList.add('botao-reabrir-chat')

			const iconeReabrir = document.createElement('i')
			iconeReabrir.setAttribute('arial-hidden', 'true')
			iconeReabrir.classList.add('v-icon')
			iconeReabrir.classList.add('notranslate')
			iconeReabrir.classList.add('material-icons')
			iconeReabrir.classList.add('theme--light')
			iconeReabrir.innerHTML = 'chevron_left'

			iconeReabrir.style.fontSize = '16px'
			iconeReabrir.style.color = 'white'

			botaoReabrir.append(iconeReabrir)

			botaoReabrir.style.height = '30px'
			botaoReabrir.style.width = '15px'
			botaoReabrir.style.position = 'fixed'
			botaoReabrir.style.bottom = '35px'
			botaoReabrir.style.right = '0px'
			botaoReabrir.style.background = 'var(--v-primary-base)'
			botaoReabrir.style.color = 'white'
			botaoReabrir.style.display = 'none'
			botaoReabrir.style.alignItems = 'center'
			botaoReabrir.style.borderTopLeftRadius = '50%'
			botaoReabrir.style.borderBottomLeftRadius = '50%'
			botaoReabrir.style.cursor = 'pointer'
			document.body.append(botaoReabrir)

			botaoReabrir.addEventListener('click', () => {
				chatContainer.style.display = 'flex'
				botaoReabrir.style.display = 'none'
			})

		}
	}
}
</script>
